<script>
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import moment from 'moment';
import router from "@/router";

export default {
  filters: {
    moment: function (date) {
      if( date === null ) {
        return "";
      }
      return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }
  },
  methods: {


    getLocations() {
      axios.get('admin/locations').then((res) => {
        this.locations = res.data.response;
        console.log(this.locations);
      });
    },

    changeLocation(e){
      this.getFilterRoles(e)
    },
    getFilterRoles(location_id = "") {
      let filters = '';
      if(location_id){
        filters = '?location_id='+location_id;
      }
      axios.get('admin/roles'+filters).then((res) => {
        this.filterRoles = res.data.response;
      });
    },

    search() {
        // if(this.searchForm.location == 0){
        //     alert("Please Select Location");
        // }else{
        router.push(`/scheduling-calendar/${this.searchForm.location}/${this.searchForm.role}`);
        // }
    },

    resetSearch() {
      this.searchForm = {
        location: 0,
        role:0,
      };
      // this.isSearching = false;
      this.getAssignments();
    },

  


  },
  page: {
    title: 'SchedulingFilters',
    meta: [
      {
        name: 'SchedulingFilters',
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: '',
      items: [
        {
          text: '',
          href: '/',
        },
      ],
      startTime: '',
      endTime: '',
      filterRoles:null,
      currentUserData : JSON.parse(localStorage.getItem('user')),
      searchForm: {
        location: 0,
        role:0,
      }
    };
  },
  mounted() {
    this.getLocations();
    this.getFilterRoles();
    // this.getApprovers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div class="me-2">
            <h5 class="card-title mb-3">Volunteer Schedule Calender Filters</h5>
          </div>

        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <form class="align-items-center form-inline border p-3" @submit.prevent="search">
              <div class="row pt-0 pb-0">
                <div class="col-md-2">
                    <b-form-select @change="changeLocation($event)" class="form-select" v-model="searchForm.location" :options="locations" value-field="id"
                         text-field="name">
                      <option slot="first" :value="0">-- All Locations --</option>
                    </b-form-select>
                </div>
                <div class="col-md-2">
                    <b-form-select class="form-select" v-model="searchForm.role" :options="filterRoles" value-field="id"
                         text-field="name">
                      <option slot="first" :value="0">-- All Roles --</option>
                    </b-form-select>
                </div>
                <div class="col-md-3 d-flex">
                  <div class="ms-auto">
                    <button type="submit" title="Search" class="btn btn-block btn-primary me-2"><i class="bx bx-search-alt-2"></i> Proceed</button>
                    <button type="button" title="Reset" @click="resetSearch" class="btn btn-light btn-reset" id="show-btn"><i class="bx bx-reset"></i> Reset</button>
                  </div>
                </div>
                <!-- <div class="col-md-12 d-flex">
                  <input
                      v-model="searchForm.name"
                      type="text"
                      class="ps-4 form-control"
                      placeholder="Type user name"
                  />

                  <b-button class="btn-find" id="show-btn" @click="search"
                            variant="primary" title="Search">
                    <i class="bx bx-search-alt-2"> Search</i>
                  </b-button>

                  <b-button class="btn-reset ms-2" id="show-btn" @click="resetSearch"
                            variant="primary" title="Reset">
                    <i class="bx bx-reset"> Reset</i>
                  </b-button>
                </div> -->
              </div>
            </form>
          </div>
        </div>

    </div>
    </div>
  </Layout>
</template>
<style scoped>
.Red {
  background-color: red;
}
.Black {
  background-color: #000000;
}
.Green {
  background-color: green;
}
.sortable {
  position: relative;
  cursor: pointer;
}
.sortable .fa {
  position: absolute;
  right: 30px;
  top: 15px;
}
.app-search input, .app-search select{
  border-top-right-radius:0px;
  border-bottom-right-radius:0px;
}
.app-search .btn-find{
  width: 40%;
  border-top-right-radius:30px;
  border-bottom-right-radius:30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  box-shadow:none;
}
.app-search .btn-reset{
  width: 40%;
  font-size: 15px;
  box-shadow:none;
  border-radius:30px;
}
</style>
